import { createContext, useContext, useState, useMemo } from "react";

const DemoFormContext = createContext({
  open: false,
  initialPlan: null,
  openForm: () => {},
  closeForm: () => {},
});

export const DemoFormProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [initialPlan, setInitialPlan] = useState(null);

  const value = useMemo(
    () => ({
      open,
      initialPlan,
      openForm: (plan = null) => {
        setInitialPlan(plan);
        setOpen(true);
      },
      closeForm: () => setOpen(false),
    }),
    [open, initialPlan]
  );

  return <DemoFormContext.Provider value={value}>{children}</DemoFormContext.Provider>;
};

export const useDemoForm = () => useContext(DemoFormContext);
